"use client";

import type { ComponentProps } from "react";
import { RetentionCreditsOfferModalContent } from "./RetentionCreditsOfferModalContent";
import { EdgenModalCreateAble } from "@components/EdgenModal";

type OpenParams = Omit<
  ComponentProps<typeof RetentionCreditsOfferModalContent>,
  "onClose"
>;

/**
 * 打开「500 Credits 挽留」弹窗（EdgenModalCreateAble）
 */
export const openRetentionCreditsOfferModal = (params: OpenParams = {}) => {
  return new Promise<{
    action: "still_want_to_cancel" | "claim_credits" | "close";
  }>((resolve) => {
    const modalInstance = EdgenModalCreateAble.call({
      destroyOnClose: true,
      className: "",
      closeStyle: {
        right: 0,
        top: 0,
      },
      showClose: false,
      contentStyle: {
        maxHeight: "100%",
        borderRadius: "0",
      },
      containerStyle: {
        height: "100%",
      },
      wrapperStyle: {
        height: "100%",
      },
      children: (
        <RetentionCreditsOfferModalContent
          onClose={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve({ action: "close" });
          }}
          onStillWantToCancel={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve({ action: "still_want_to_cancel" });
          }}
          onClaimCredits={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve({ action: "claim_credits" });
          }}
          {...params}
        />
      ),
    });
  });
};
